import { Dropdown } from "../Dropdown";
import { Icon } from "../Icon";
import { Text } from "../Text";
import { ControlButton } from "./ControlButton";
import { WINDOW_OPTIONS, type WindowOption } from "./monitoringWindow";

type Props = {
  value: WindowOption;
  onChange: (option: WindowOption) => void;
};

export function MonitoringWindowPicker({ value, onChange }: Props) {
  return (
    <Dropdown
      align="bottom"
      opener={
        <ControlButton type="button">
          <Icon name="clock" size={12} />
          <Text variant="text-small-md" ellipsis>
            {value.label}
          </Text>
          <Icon name="chevron-down" size={12} color="var(--text-secondary)" />
        </ControlButton>
      }
      sections={[
        {
          items: WINDOW_OPTIONS.map((option) => ({
            type: "button" as const,
            key: option.value,
            left: <Icon name="clock" size={16} color="var(--text-primary)" />,
            label: option.label,
            selected: option.value === value.value,
            right:
              option.value === value.value ? (
                <Icon name="check" size={12} color="var(--text-secondary)" />
              ) : undefined,
            onClick: () => onChange(option),
          })),
        },
      ]}
    />
  );
}
